<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem>广告管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">广告管理</div>
      </div>
      <div class="header-tool-box" v-if="showTabs == 1 || showTabs == 2 || showTabs == 3">
        <div class="htb-item" @click="show=true;">
          <span>添加广告</span>
        </div>
      </div>
      <div class="header-tool-box" v-if="showTabs == 4">
        <div class="htb-item" @click="showAudience=true;">
          <span>添加广告</span>
        </div>
      </div>
    </div>
    <div class="header-switch">
      <div class="header-switch-text">广告的设置</div>
    </div>

    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="首页banner" name="1">
          <adHome ref="adHome" @editFinish="init()" />
        </TabPane>
        <TabPane label="供需页banner" name="2">
          <adSupply ref="adSupply" @editFinish="init()" />
        </TabPane>
        <TabPane label="展商中心顶部banner" name="3">
          <adTop ref="adTop" @editFinish="init()" />
        </TabPane>
        <!-- <TabPane label="观众中心首页banner" name="4">
          <adAudience ref="adAudience" @editFinish="init()" />
        </TabPane> -->
      </Tabs>
    </div>

    <commonAdAdd 
      :show="show"
      @finish="init()"
      @close="show=false;"
    />
    <commonAudienceAdAdd
      :show="showAudience" 
      @finish="$refs['adAudience'].init();"
      @close="showAudience=false;"
    />
  </div>
</template>

<script>
import adHome from "../components/common-ad-home.vue";
import adSupply from "../components/common-ad-supply.vue";
import adTop from "../components/common-ad-top.vue";
import adAudience from "../components/common-ad-audience.vue";
import commonAdAdd from "../components/common-ad-add.vue";
import commonAudienceAdAdd from "../components/common-audiencead-add.vue";

export default {
  name: "host-common-ad",
  data() {
    return {
      showTabs: "1",
      show: false,
      showAudience: false,
    };
  },
  methods: {
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=home`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=supply`);
      } else if (name === "3") {
        this.$router.push(`${this.$route.path}?type=top`);
      } else if (name === "4") {
        this.$router.push(`${this.$route.path}?type=audience`);
      }
    },
    init() {
      this.$refs['adHome'].init();
      this.$refs['adSupply'].init();
      this.$refs['adTop'].init();
    }
  },
  created() {
    let query = this.$route.query;
    if (query && query.type && query.type === "home") {
      this.showTabs = "1";
    }
    if (query && query.type && query.type === "supply") {
      this.showTabs = "2";
    }
    if (query && query.type && query.type === "top") {
      this.showTabs = "3";
    }
    if (query && query.type && query.type === "audience") {
      this.showTabs = "4";
    }
  },
  components: {
    adHome,
    adSupply,
    adTop,
    adAudience,
    commonAdAdd,
    commonAudienceAdAdd
  }
};
</script>

<style lang="scss" scoped>
.common-ad {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;
    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
    &-box {
      flex: 1;
      text-align: right;
    }
  }
}
</style>